export const NAVBAR_HEIGHT = 77;
export const NAVBAR_HEIGHT_MOBILE = 56;
